import { __assign, __awaiter, __extends, __generator } from "tslib";
import { environment } from 'src/environments/environment';
import { HttpClientBase } from './httpClientBase';
var S3Client = /** @class */ (function (_super) {
    __extends(S3Client, _super);
    function S3Client(options) {
        return _super.call(this, __assign(__assign({}, options), { baseUrl: environment.api.s3Proxy.endpoint })) || this;
    }
    S3Client.prototype.getSignedUrl = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetch("clinic/read", {
                        body: JSON.stringify({ url: url }),
                        headers: { 'content-type': 'application/json' },
                        method: 'POST',
                    })];
            });
        });
    };
    return S3Client;
}(HttpClientBase));
export { S3Client };
